<div class="page-wrapper" [ngClass]="{ 'toggled': activeSidebar && !isMobileApp }">

  @if (!isMobileApp) {
    <cricteams-sidebar (sidebarToggle)="toggleClass()" />
  }

  <main class="page-content bg-gray-50 dark:bg-slate-800">

    @if (!isMobileApp) {
      <cricteams-header (toggleClass)="toggleClass()" (upgradeClick)="onHeaderUpgradeClick()" />
      <cricteams-upgrade-modal />
    }

      <div class="container-fluid relative px-3">
        <div class="layout-specing" [ngClass]="{ 'mobile-app': isMobileApp }">
          <div class="grid gap-6 font-montserrat grid-cols-3 random" >
            <div class="col-span-3 relative" >
              @if (isSectionLoading) {
                <cricteams-section-loading [ngStyle]="{'background-color' : currentUrl ? '#ffffff' : 'transparent'}"></cricteams-section-loading>
              }
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      </div>

    @if (!isMobileApp) {
      <cricteams-app-footer/>
    }

  </main>

</div>
